import React from 'react';
import Copy from '../../assets/copy.svg';
import { useLanguage } from '../../context/language';
import { getStrLang } from '../Translate';
import toast, { Toaster } from 'react-hot-toast';

export default function InputForm(props) {  

  const { lang } = useLanguage();


  
  const notify = () => {     
    navigator.clipboard.writeText(props.value);   
    toast.success(getStrLang(lang.nameLang, "notify_toast"));
  }
  return (    
    <div className="form-group form-inputs">
      <label htmlFor={props.for} data-lang-str={props.data_lang_label} className="bold_text_ted"></label>
      <div className="input-line">
        <input type="text" id={props.for} className="form-control form-control-lg" value={props.value}/>                
        <div className="copy-area" onClick={() => notify()}>
          <img src={Copy} alt="Copy" />
          <Toaster
            toastOptions={{
              className: '',
              style: {
                border: '1px solid #0d4fb8',
                color: '#0d4fb8',
                padding: '12px',
                top: '300px', 
              //  position: 'relative',
              },
            }}
          /> 
        </div>
      </div>
    </div>
  );
}
